/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { AdminWriteElevationPayload } from '../models/adminWriteElevationPayload';

import type { AdminWriteElevationRequest } from '../models/adminWriteElevationRequest';

import type { DebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetParams } from '../models/debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetParams';

import type { GrantAccessRequest } from '../models/grantAccessRequest';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { ListAccessibleRequest } from '../models/listAccessibleRequest';

import type { ListRolesApiV1PermissionsRolesGetParams } from '../models/listRolesApiV1PermissionsRolesGetParams';

import type { PermissionCheckRequest } from '../models/permissionCheckRequest';

import type { PermissionCheckResponse } from '../models/permissionCheckResponse';

import type { RevokeAccessRequest } from '../models/revokeAccessRequest';

import type { RoleCreateRequest } from '../models/roleCreateRequest';

import type { RoleUpdateRequest } from '../models/roleUpdateRequest';

import type { TransferOwnershipRequest } from '../models/transferOwnershipRequest';

import type { UserRoleAssignRequest } from '../models/userRoleAssignRequest';

import type { VisibilityModePayload } from '../models/visibilityModePayload';

import type { VisibilityModeUpdate } from '../models/visibilityModeUpdate';

import type { VisibilityModesResponse } from '../models/visibilityModesResponse';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Check if user can perform action on resource.

Request:
```json
{
  "user_id": "uuid",  // Optional, defaults to current user
  "action": "update",
  "resource": {
    "type": "tasks.board",
    "id": "uuid"
  }
}
```

Response:
```json
{
  "allowed": true,
  "relation": "editor",
  "source": "direct",
  "source_detail": "Shared directly"
}
```
 * @summary Check Permission
 */
export const checkPermissionApiV1PermissionsCheckPost = (
  permissionCheckRequest: PermissionCheckRequest,
  signal?: AbortSignal
) => {
  return customInstance<PermissionCheckResponse>({
    url: `/api/v1/permissions/check`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: permissionCheckRequest,
    signal
  });
};

export const getCheckPermissionApiV1PermissionsCheckPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkPermissionApiV1PermissionsCheckPost>>,
    TError,
    { data: PermissionCheckRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkPermissionApiV1PermissionsCheckPost>>,
  TError,
  { data: PermissionCheckRequest },
  TContext
> => {
  const mutationKey = ['checkPermissionApiV1PermissionsCheckPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkPermissionApiV1PermissionsCheckPost>>,
    { data: PermissionCheckRequest }
  > = (props) => {
    const { data } = props ?? {};

    return checkPermissionApiV1PermissionsCheckPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckPermissionApiV1PermissionsCheckPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof checkPermissionApiV1PermissionsCheckPost>>
  >;
export type CheckPermissionApiV1PermissionsCheckPostMutationBody =
  PermissionCheckRequest;
export type CheckPermissionApiV1PermissionsCheckPostMutationError =
  HTTPValidationError;

/**
 * @summary Check Permission
 */
export const useCheckPermissionApiV1PermissionsCheckPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof checkPermissionApiV1PermissionsCheckPost>>,
      TError,
      { data: PermissionCheckRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof checkPermissionApiV1PermissionsCheckPost>>,
  TError,
  { data: PermissionCheckRequest },
  TContext
> => {
  const mutationOptions =
    getCheckPermissionApiV1PermissionsCheckPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List all resources of a type that user can access.

Request:
```json
{
  "user_id": "uuid",
  "resource_type": "tasks.board",
  "min_relation": "viewer",
  "limit": 100,
  "offset": 0
}
```

Response:
```json
{
  "resources": [
    {"id": "uuid", "relation": "owner"},
    {"id": "uuid", "relation": "editor"}
  ],
  "total": 42
}
```
 * @summary List Accessible Resources
 */
export const listAccessibleResourcesApiV1PermissionsListPost = (
  listAccessibleRequest: ListAccessibleRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/list`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: listAccessibleRequest,
    signal
  });
};

export const getListAccessibleResourcesApiV1PermissionsListPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof listAccessibleResourcesApiV1PermissionsListPost>
      >,
      TError,
      { data: ListAccessibleRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof listAccessibleResourcesApiV1PermissionsListPost>>,
    TError,
    { data: ListAccessibleRequest },
    TContext
  > => {
    const mutationKey = ['listAccessibleResourcesApiV1PermissionsListPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof listAccessibleResourcesApiV1PermissionsListPost>
      >,
      { data: ListAccessibleRequest }
    > = (props) => {
      const { data } = props ?? {};

      return listAccessibleResourcesApiV1PermissionsListPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ListAccessibleResourcesApiV1PermissionsListPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof listAccessibleResourcesApiV1PermissionsListPost>>
  >;
export type ListAccessibleResourcesApiV1PermissionsListPostMutationBody =
  ListAccessibleRequest;
export type ListAccessibleResourcesApiV1PermissionsListPostMutationError =
  HTTPValidationError;

/**
 * @summary List Accessible Resources
 */
export const useListAccessibleResourcesApiV1PermissionsListPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof listAccessibleResourcesApiV1PermissionsListPost>
      >,
      TError,
      { data: ListAccessibleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof listAccessibleResourcesApiV1PermissionsListPost>>,
  TError,
  { data: ListAccessibleRequest },
  TContext
> => {
  const mutationOptions =
    getListAccessibleResourcesApiV1PermissionsListPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Grant access to a resource.

Requires 'owner' relation on the resource to share it.

Request:
```json
{
  "subject": {
    "type": "group",
    "id": "uuid"
  },
  "relation": "editor",
  "resource": {
    "type": "tasks.board",
    "id": "uuid"
  },
  "expires_at": "2025-12-31T23:59:59Z"  // Optional
}
```
 * @summary Grant Access
 */
export const grantAccessApiV1PermissionsGrantPost = (
  grantAccessRequest: GrantAccessRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/grant`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: grantAccessRequest,
    signal
  });
};

export const getGrantAccessApiV1PermissionsGrantPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantAccessApiV1PermissionsGrantPost>>,
    TError,
    { data: GrantAccessRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantAccessApiV1PermissionsGrantPost>>,
  TError,
  { data: GrantAccessRequest },
  TContext
> => {
  const mutationKey = ['grantAccessApiV1PermissionsGrantPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantAccessApiV1PermissionsGrantPost>>,
    { data: GrantAccessRequest }
  > = (props) => {
    const { data } = props ?? {};

    return grantAccessApiV1PermissionsGrantPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantAccessApiV1PermissionsGrantPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantAccessApiV1PermissionsGrantPost>>
>;
export type GrantAccessApiV1PermissionsGrantPostMutationBody =
  GrantAccessRequest;
export type GrantAccessApiV1PermissionsGrantPostMutationError =
  HTTPValidationError;

/**
 * @summary Grant Access
 */
export const useGrantAccessApiV1PermissionsGrantPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof grantAccessApiV1PermissionsGrantPost>>,
      TError,
      { data: GrantAccessRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof grantAccessApiV1PermissionsGrantPost>>,
  TError,
  { data: GrantAccessRequest },
  TContext
> => {
  const mutationOptions =
    getGrantAccessApiV1PermissionsGrantPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Revoke access from a resource.

Requires 'owner' relation on the resource.

Request:
```json
{
  "subject": {
    "type": "group",
    "id": "uuid"
  },
  "relation": "editor",  // Optional, null = revoke all relations
  "resource": {
    "type": "tasks.board",
    "id": "uuid"
  }
}
```
 * @summary Revoke Access
 */
export const revokeAccessApiV1PermissionsRevokeDelete = (
  revokeAccessRequest: RevokeAccessRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/revoke`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: revokeAccessRequest
  });
};

export const getRevokeAccessApiV1PermissionsRevokeDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeAccessApiV1PermissionsRevokeDelete>>,
    TError,
    { data: RevokeAccessRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeAccessApiV1PermissionsRevokeDelete>>,
  TError,
  { data: RevokeAccessRequest },
  TContext
> => {
  const mutationKey = ['revokeAccessApiV1PermissionsRevokeDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeAccessApiV1PermissionsRevokeDelete>>,
    { data: RevokeAccessRequest }
  > = (props) => {
    const { data } = props ?? {};

    return revokeAccessApiV1PermissionsRevokeDelete(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeAccessApiV1PermissionsRevokeDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof revokeAccessApiV1PermissionsRevokeDelete>>
  >;
export type RevokeAccessApiV1PermissionsRevokeDeleteMutationBody =
  RevokeAccessRequest;
export type RevokeAccessApiV1PermissionsRevokeDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Revoke Access
 */
export const useRevokeAccessApiV1PermissionsRevokeDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof revokeAccessApiV1PermissionsRevokeDelete>>,
      TError,
      { data: RevokeAccessRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof revokeAccessApiV1PermissionsRevokeDelete>>,
  TError,
  { data: RevokeAccessRequest },
  TContext
> => {
  const mutationOptions =
    getRevokeAccessApiV1PermissionsRevokeDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Transfer ownership of a resource from one user to another.

Atomically revokes the outgoing owner's ``owner`` tuple and grants it to the
new owner. Requires the ``transfer`` action (OWNER relation) on the resource.
``from_user_id`` defaults to the caller.

Request:
```json
{
  "to_user_id": "uuid",
  "from_user_id": "uuid",           // Optional, defaults to caller
  "resource": {"type": "tasks.board", "id": "uuid"}
}
```
 * @summary Transfer Ownership
 */
export const transferOwnershipApiV1PermissionsTransferOwnershipPost = (
  transferOwnershipRequest: TransferOwnershipRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/transfer-ownership`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: transferOwnershipRequest,
    signal
  });
};

export const getTransferOwnershipApiV1PermissionsTransferOwnershipPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof transferOwnershipApiV1PermissionsTransferOwnershipPost
        >
      >,
      TError,
      { data: TransferOwnershipRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof transferOwnershipApiV1PermissionsTransferOwnershipPost>
    >,
    TError,
    { data: TransferOwnershipRequest },
    TContext
  > => {
    const mutationKey = [
      'transferOwnershipApiV1PermissionsTransferOwnershipPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof transferOwnershipApiV1PermissionsTransferOwnershipPost
        >
      >,
      { data: TransferOwnershipRequest }
    > = (props) => {
      const { data } = props ?? {};

      return transferOwnershipApiV1PermissionsTransferOwnershipPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type TransferOwnershipApiV1PermissionsTransferOwnershipPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof transferOwnershipApiV1PermissionsTransferOwnershipPost>
    >
  >;
export type TransferOwnershipApiV1PermissionsTransferOwnershipPostMutationBody =
  TransferOwnershipRequest;
export type TransferOwnershipApiV1PermissionsTransferOwnershipPostMutationError =
  HTTPValidationError;

/**
 * @summary Transfer Ownership
 */
export const useTransferOwnershipApiV1PermissionsTransferOwnershipPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof transferOwnershipApiV1PermissionsTransferOwnershipPost
        >
      >,
      TError,
      { data: TransferOwnershipRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof transferOwnershipApiV1PermissionsTransferOwnershipPost>
  >,
  TError,
  { data: TransferOwnershipRequest },
  TContext
> => {
  const mutationOptions =
    getTransferOwnershipApiV1PermissionsTransferOwnershipPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Grant (or refresh) the caller's §4.1 JIT write elevation on ONE governed
record — the audited "Edit as admin" step-up (design §4.1).

Eligibility is exactly the read-override gate (`admin_override_applies`:
Full-Access role on the EFFECTIVE identity, an enforced shareable type, and a
mode that is NOT an open mode — i.e. not `everyone` / `everyone_edit`, since in
an open mode nothing is governed per-record) AND the type is not
override-exempt. The request consumes a
fresh record-bound step-up proof, so an idle admin session can never be
ridden into an elevation. Loud by design: audited + owner-notified.
 * @summary Grant Admin Write Elevation
 */
export const grantAdminWriteElevationApiV1PermissionsAdminElevationPost = (
  adminWriteElevationRequest: AdminWriteElevationRequest,
  signal?: AbortSignal
) => {
  return customInstance<AdminWriteElevationPayload>({
    url: `/api/v1/permissions/admin-elevation`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: adminWriteElevationRequest,
    signal
  });
};

export const getGrantAdminWriteElevationApiV1PermissionsAdminElevationPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof grantAdminWriteElevationApiV1PermissionsAdminElevationPost
        >
      >,
      TError,
      { data: AdminWriteElevationRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof grantAdminWriteElevationApiV1PermissionsAdminElevationPost
      >
    >,
    TError,
    { data: AdminWriteElevationRequest },
    TContext
  > => {
    const mutationKey = [
      'grantAdminWriteElevationApiV1PermissionsAdminElevationPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof grantAdminWriteElevationApiV1PermissionsAdminElevationPost
        >
      >,
      { data: AdminWriteElevationRequest }
    > = (props) => {
      const { data } = props ?? {};

      return grantAdminWriteElevationApiV1PermissionsAdminElevationPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type GrantAdminWriteElevationApiV1PermissionsAdminElevationPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof grantAdminWriteElevationApiV1PermissionsAdminElevationPost
      >
    >
  >;
export type GrantAdminWriteElevationApiV1PermissionsAdminElevationPostMutationBody =
  AdminWriteElevationRequest;
export type GrantAdminWriteElevationApiV1PermissionsAdminElevationPostMutationError =
  HTTPValidationError;

/**
 * @summary Grant Admin Write Elevation
 */
export const useGrantAdminWriteElevationApiV1PermissionsAdminElevationPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof grantAdminWriteElevationApiV1PermissionsAdminElevationPost
        >
      >,
      TError,
      { data: AdminWriteElevationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof grantAdminWriteElevationApiV1PermissionsAdminElevationPost
    >
  >,
  TError,
  { data: AdminWriteElevationRequest },
  TContext
> => {
  const mutationOptions =
    getGrantAdminWriteElevationApiV1PermissionsAdminElevationPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * End the caller's active elevation early ("Done editing"). Idempotent —
releasing an absent/expired elevation is a no-op, not an error. Audited.
 * @summary Release Admin Write Elevation
 */
export const releaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDelete =
  (objectType: string, objectId: string) => {
    return customInstance<AdminWriteElevationPayload>({
      url: `/api/v1/permissions/admin-elevation/${objectType}/${objectId}`,
      method: 'DELETE'
    });
  };

export const getReleaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof releaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDelete
        >
      >,
      TError,
      { objectType: string; objectId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof releaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDelete
      >
    >,
    TError,
    { objectType: string; objectId: string },
    TContext
  > => {
    const mutationKey = [
      'releaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof releaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDelete
        >
      >,
      { objectType: string; objectId: string }
    > = (props) => {
      const { objectType, objectId } = props ?? {};

      return releaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDelete(
        objectType,
        objectId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReleaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof releaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDelete
      >
    >
  >;

export type ReleaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Release Admin Write Elevation
 */
export const useReleaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof releaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDelete
          >
        >,
        TError,
        { objectType: string; objectId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof releaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDelete
      >
    >,
    TError,
    { objectType: string; objectId: string },
    TContext
  > => {
    const mutationOptions =
      getReleaseAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The caller's current elevation state on one record — drives the frontend
"Admin override active (until HH:MM)" banner state. A pure read (no audit
row; the audited moments are grant, each write, and release).
 * @summary Get Admin Write Elevation
 */
export const getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet =
  (objectType: string, objectId: string, signal?: AbortSignal) => {
    return customInstance<AdminWriteElevationPayload>({
      url: `/api/v1/permissions/admin-elevation/${objectType}/${objectId}`,
      method: 'GET',
      signal
    });
  };

export const getGetAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGetQueryKey =
  (objectType?: string, objectId?: string) => {
    return [
      `/api/v1/permissions/admin-elevation/${objectType}/${objectId}`
    ] as const;
  };

export const getGetAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    objectType: string,
    objectId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGetQueryKey(
        objectType,
        objectId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
        >
      >
    > = ({ signal }) =>
      getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet(
        objectType,
        objectId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(objectType && objectId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
      >
    >
  >;
export type GetAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGetQueryError =
  HTTPValidationError;

export function useGetAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  objectId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  objectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  objectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Admin Write Elevation
 */

export function useGetAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  objectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAdminWriteElevationApiV1PermissionsAdminElevationObjectTypeObjectIdGetQueryOptions(
      objectType,
      objectId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get list of who has access to an entity.

Note: Any authenticated user can view the access list. Modify permissions
(grant/revoke) still requires owner relation.

Response:
```json
{
  "access": [
    {
      "subject": {"type": "user", "id": "uuid", "name": "Sarah Chen"},
      "relation": "owner",
      "source": "direct",
      "granted_at": "2025-01-15T10:30:00Z"
    },
    {
      "subject": {"type": "group", "id": "uuid", "name": "Sales Team"},
      "relation": "viewer",
      "source": "rule",
      "source_rule": {"id": "uuid", "name": "Team Visibility"}
    }
  ],
  "inherited_access": [
    {
      "subject": {"type": "user", "id": "uuid", "name": "John Doe"},
      "relation": "editor",
      "source": "inherited",
      "source_detail": "Via workspace: Project Alpha"
    }
  ],
  "parent_entity": {
    "type": "tasks.workspace",
    "id": "uuid",
    "name": "Project Alpha"
  }
}
```
 * @summary Get Entity Access List
 */
export const getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet = (
  objectType: string,
  objectId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/access/${objectType}/${objectId}`,
    method: 'GET',
    signal
  });
};

export const getGetEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGetQueryKey =
  (objectType?: string, objectId?: string) => {
    return [`/api/v1/permissions/access/${objectType}/${objectId}`] as const;
  };

export const getGetEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    objectType: string,
    objectId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGetQueryKey(
        objectType,
        objectId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
        >
      >
    > = ({ signal }) =>
      getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet(
        objectType,
        objectId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(objectType && objectId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
      >
    >
  >;
export type GetEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGetQueryError =
  HTTPValidationError;

export function useGetEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  objectId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  objectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  objectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Entity Access List
 */

export function useGetEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  objectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEntityAccessListApiV1PermissionsAccessObjectTypeObjectIdGetQueryOptions(
      objectType,
      objectId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Debug endpoint to diagnose permission issues for a specific user.

Admin only; all lookups are scoped to the caller's tenant.
 * @summary Debug User Permission
 */
export const debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet = (
  objectType: string,
  objectId: string,
  params: DebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/debug/${objectType}/${objectId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getDebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetQueryKey =
  (
    objectType?: string,
    objectId?: string,
    params?: DebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetParams
  ) => {
    return [
      `/api/v1/permissions/debug/${objectType}/${objectId}`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getDebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    objectType: string,
    objectId: string,
    params: DebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getDebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetQueryKey(
        objectType,
        objectId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
        >
      >
    > = ({ signal }) =>
      debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet(
        objectType,
        objectId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(objectType && objectId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type DebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
      >
    >
  >;
export type DebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetQueryError =
  HTTPValidationError;

export function useDebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  objectId: string,
  params: DebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  objectId: string,
  params: DebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  objectId: string,
  params: DebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Debug User Permission
 */

export function useDebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  objectId: string,
  params: DebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof debugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDebugUserPermissionApiV1PermissionsDebugObjectTypeObjectIdGetQueryOptions(
      objectType,
      objectId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all roles in the tenant.

Response:
```json
{
  "roles": [
    {
      "id": "uuid",
      "name": "Full Access",
      "description": "Full access to all tenant resources",
      "is_system_role": true,
      "is_custom": false,
      "permissions": ["*.*.*"]
    }
  ]
}
```
 * @summary List Roles
 */
export const listRolesApiV1PermissionsRolesGet = (
  params?: ListRolesApiV1PermissionsRolesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/roles`,
    method: 'GET',
    params,
    signal
  });
};

export const getListRolesApiV1PermissionsRolesGetQueryKey = (
  params?: ListRolesApiV1PermissionsRolesGetParams
) => {
  return [`/api/v1/permissions/roles`, ...(params ? [params] : [])] as const;
};

export const getListRolesApiV1PermissionsRolesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
  TError = HTTPValidationError
>(
  params?: ListRolesApiV1PermissionsRolesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListRolesApiV1PermissionsRolesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>
  > = ({ signal }) => listRolesApiV1PermissionsRolesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListRolesApiV1PermissionsRolesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>
>;
export type ListRolesApiV1PermissionsRolesGetQueryError = HTTPValidationError;

export function useListRolesApiV1PermissionsRolesGet<
  TData = Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListRolesApiV1PermissionsRolesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
          TError,
          Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListRolesApiV1PermissionsRolesGet<
  TData = Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
  TError = HTTPValidationError
>(
  params?: ListRolesApiV1PermissionsRolesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
          TError,
          Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRolesApiV1PermissionsRolesGet<
  TData = Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
  TError = HTTPValidationError
>(
  params?: ListRolesApiV1PermissionsRolesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Roles
 */

export function useListRolesApiV1PermissionsRolesGet<
  TData = Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
  TError = HTTPValidationError
>(
  params?: ListRolesApiV1PermissionsRolesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRolesApiV1PermissionsRolesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListRolesApiV1PermissionsRolesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a custom role. Requires admin access.
 * @summary Create Role
 */
export const createRoleApiV1PermissionsRolesPost = (
  roleCreateRequest: RoleCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/roles`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: roleCreateRequest,
    signal
  });
};

export const getCreateRoleApiV1PermissionsRolesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRoleApiV1PermissionsRolesPost>>,
    TError,
    { data: RoleCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRoleApiV1PermissionsRolesPost>>,
  TError,
  { data: RoleCreateRequest },
  TContext
> => {
  const mutationKey = ['createRoleApiV1PermissionsRolesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRoleApiV1PermissionsRolesPost>>,
    { data: RoleCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createRoleApiV1PermissionsRolesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRoleApiV1PermissionsRolesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRoleApiV1PermissionsRolesPost>>
>;
export type CreateRoleApiV1PermissionsRolesPostMutationBody = RoleCreateRequest;
export type CreateRoleApiV1PermissionsRolesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Role
 */
export const useCreateRoleApiV1PermissionsRolesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRoleApiV1PermissionsRolesPost>>,
      TError,
      { data: RoleCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createRoleApiV1PermissionsRolesPost>>,
  TError,
  { data: RoleCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateRoleApiV1PermissionsRolesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a specific role by ID.
 * @summary Get Role
 */
export const getRoleApiV1PermissionsRolesRoleIdGet = (
  roleId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/roles/${roleId}`,
    method: 'GET',
    signal
  });
};

export const getGetRoleApiV1PermissionsRolesRoleIdGetQueryKey = (
  roleId?: string
) => {
  return [`/api/v1/permissions/roles/${roleId}`] as const;
};

export const getGetRoleApiV1PermissionsRolesRoleIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
  TError = HTTPValidationError
>(
  roleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRoleApiV1PermissionsRolesRoleIdGetQueryKey(roleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>
  > = ({ signal }) => getRoleApiV1PermissionsRolesRoleIdGet(roleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!roleId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRoleApiV1PermissionsRolesRoleIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>
>;
export type GetRoleApiV1PermissionsRolesRoleIdGetQueryError =
  HTTPValidationError;

export function useGetRoleApiV1PermissionsRolesRoleIdGet<
  TData = Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
  TError = HTTPValidationError
>(
  roleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
          TError,
          Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRoleApiV1PermissionsRolesRoleIdGet<
  TData = Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
  TError = HTTPValidationError
>(
  roleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
          TError,
          Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRoleApiV1PermissionsRolesRoleIdGet<
  TData = Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
  TError = HTTPValidationError
>(
  roleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Role
 */

export function useGetRoleApiV1PermissionsRolesRoleIdGet<
  TData = Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
  TError = HTTPValidationError
>(
  roleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleApiV1PermissionsRolesRoleIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRoleApiV1PermissionsRolesRoleIdGetQueryOptions(
    roleId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a custom role. System roles cannot be modified.
 * @summary Update Role
 */
export const updateRoleApiV1PermissionsRolesRoleIdPut = (
  roleId: string,
  roleUpdateRequest: RoleUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/roles/${roleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: roleUpdateRequest
  });
};

export const getUpdateRoleApiV1PermissionsRolesRoleIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRoleApiV1PermissionsRolesRoleIdPut>>,
    TError,
    { roleId: string; data: RoleUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRoleApiV1PermissionsRolesRoleIdPut>>,
  TError,
  { roleId: string; data: RoleUpdateRequest },
  TContext
> => {
  const mutationKey = ['updateRoleApiV1PermissionsRolesRoleIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRoleApiV1PermissionsRolesRoleIdPut>>,
    { roleId: string; data: RoleUpdateRequest }
  > = (props) => {
    const { roleId, data } = props ?? {};

    return updateRoleApiV1PermissionsRolesRoleIdPut(roleId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRoleApiV1PermissionsRolesRoleIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateRoleApiV1PermissionsRolesRoleIdPut>>
  >;
export type UpdateRoleApiV1PermissionsRolesRoleIdPutMutationBody =
  RoleUpdateRequest;
export type UpdateRoleApiV1PermissionsRolesRoleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Role
 */
export const useUpdateRoleApiV1PermissionsRolesRoleIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateRoleApiV1PermissionsRolesRoleIdPut>>,
      TError,
      { roleId: string; data: RoleUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateRoleApiV1PermissionsRolesRoleIdPut>>,
  TError,
  { roleId: string; data: RoleUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateRoleApiV1PermissionsRolesRoleIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a custom role. System roles cannot be deleted.
 * @summary Delete Role
 */
export const deleteRoleApiV1PermissionsRolesRoleIdDelete = (roleId: string) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/roles/${roleId}`,
    method: 'DELETE'
  });
};

export const getDeleteRoleApiV1PermissionsRolesRoleIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRoleApiV1PermissionsRolesRoleIdDelete>>,
    TError,
    { roleId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRoleApiV1PermissionsRolesRoleIdDelete>>,
  TError,
  { roleId: string },
  TContext
> => {
  const mutationKey = ['deleteRoleApiV1PermissionsRolesRoleIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRoleApiV1PermissionsRolesRoleIdDelete>>,
    { roleId: string }
  > = (props) => {
    const { roleId } = props ?? {};

    return deleteRoleApiV1PermissionsRolesRoleIdDelete(roleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRoleApiV1PermissionsRolesRoleIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteRoleApiV1PermissionsRolesRoleIdDelete>>
  >;

export type DeleteRoleApiV1PermissionsRolesRoleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Role
 */
export const useDeleteRoleApiV1PermissionsRolesRoleIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRoleApiV1PermissionsRolesRoleIdDelete>>,
      TError,
      { roleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRoleApiV1PermissionsRolesRoleIdDelete>>,
  TError,
  { roleId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteRoleApiV1PermissionsRolesRoleIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get all roles assigned to a user.

Response:
```json
{
  "roles": [
    {
      "role_id": "uuid",
      "role_name": "Manager",
      "scope_type": "company",
      "scope_id": "uuid",
      "scope_name": "NYC Office",
      "granted_at": "2025-01-15T10:30:00Z",
      "granted_by": "uuid"
    }
  ]
}
```
 * @summary Get User Roles
 */
export const getUserRolesApiV1PermissionsUserRolesUserIdGet = (
  userId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/user-roles/${userId}`,
    method: 'GET',
    signal
  });
};

export const getGetUserRolesApiV1PermissionsUserRolesUserIdGetQueryKey = (
  userId?: string
) => {
  return [`/api/v1/permissions/user-roles/${userId}`] as const;
};

export const getGetUserRolesApiV1PermissionsUserRolesUserIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
  >,
  TError = HTTPValidationError
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserRolesApiV1PermissionsUserRolesUserIdGetQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>>
  > = ({ signal }) =>
    getUserRolesApiV1PermissionsUserRolesUserIdGet(userId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserRolesApiV1PermissionsUserRolesUserIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>>
  >;
export type GetUserRolesApiV1PermissionsUserRolesUserIdGetQueryError =
  HTTPValidationError;

export function useGetUserRolesApiV1PermissionsUserRolesUserIdGet<
  TData = Awaited<
    ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
  >,
  TError = HTTPValidationError
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserRolesApiV1PermissionsUserRolesUserIdGet<
  TData = Awaited<
    ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
  >,
  TError = HTTPValidationError
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserRolesApiV1PermissionsUserRolesUserIdGet<
  TData = Awaited<
    ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
  >,
  TError = HTTPValidationError
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get User Roles
 */

export function useGetUserRolesApiV1PermissionsUserRolesUserIdGet<
  TData = Awaited<
    ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
  >,
  TError = HTTPValidationError
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserRolesApiV1PermissionsUserRolesUserIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetUserRolesApiV1PermissionsUserRolesUserIdGetQueryOptions(
      userId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Assign a role to a user. Requires admin access.

Supports scoped roles:
- Global: scope_type=null, scope_id=null (role applies everywhere)
- Company-scoped: scope_type="company", scope_id=company_uuid
- Group-scoped: scope_type="group", scope_id=group_uuid
- Office-scoped: scope_type="office", scope_id=office_uuid
 * @summary Assign Role To User
 */
export const assignRoleToUserApiV1PermissionsUserRolesPost = (
  userRoleAssignRequest: UserRoleAssignRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/user-roles`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: userRoleAssignRequest,
    signal
  });
};

export const getAssignRoleToUserApiV1PermissionsUserRolesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignRoleToUserApiV1PermissionsUserRolesPost>>,
    TError,
    { data: UserRoleAssignRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignRoleToUserApiV1PermissionsUserRolesPost>>,
  TError,
  { data: UserRoleAssignRequest },
  TContext
> => {
  const mutationKey = ['assignRoleToUserApiV1PermissionsUserRolesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignRoleToUserApiV1PermissionsUserRolesPost>>,
    { data: UserRoleAssignRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignRoleToUserApiV1PermissionsUserRolesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignRoleToUserApiV1PermissionsUserRolesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof assignRoleToUserApiV1PermissionsUserRolesPost>>
  >;
export type AssignRoleToUserApiV1PermissionsUserRolesPostMutationBody =
  UserRoleAssignRequest;
export type AssignRoleToUserApiV1PermissionsUserRolesPostMutationError =
  HTTPValidationError;

/**
 * @summary Assign Role To User
 */
export const useAssignRoleToUserApiV1PermissionsUserRolesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof assignRoleToUserApiV1PermissionsUserRolesPost>>,
      TError,
      { data: UserRoleAssignRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof assignRoleToUserApiV1PermissionsUserRolesPost>>,
  TError,
  { data: UserRoleAssignRequest },
  TContext
> => {
  const mutationOptions =
    getAssignRoleToUserApiV1PermissionsUserRolesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Revoke a role assignment by ID. Requires admin access.
 * @summary Revoke User Role
 */
export const revokeUserRoleApiV1PermissionsUserRolesAssignmentIdDelete = (
  assignmentId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/user-roles/${assignmentId}`,
    method: 'DELETE'
  });
};

export const getRevokeUserRoleApiV1PermissionsUserRolesAssignmentIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof revokeUserRoleApiV1PermissionsUserRolesAssignmentIdDelete
        >
      >,
      TError,
      { assignmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof revokeUserRoleApiV1PermissionsUserRolesAssignmentIdDelete
      >
    >,
    TError,
    { assignmentId: string },
    TContext
  > => {
    const mutationKey = [
      'revokeUserRoleApiV1PermissionsUserRolesAssignmentIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof revokeUserRoleApiV1PermissionsUserRolesAssignmentIdDelete
        >
      >,
      { assignmentId: string }
    > = (props) => {
      const { assignmentId } = props ?? {};

      return revokeUserRoleApiV1PermissionsUserRolesAssignmentIdDelete(
        assignmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RevokeUserRoleApiV1PermissionsUserRolesAssignmentIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof revokeUserRoleApiV1PermissionsUserRolesAssignmentIdDelete
      >
    >
  >;

export type RevokeUserRoleApiV1PermissionsUserRolesAssignmentIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Revoke User Role
 */
export const useRevokeUserRoleApiV1PermissionsUserRolesAssignmentIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof revokeUserRoleApiV1PermissionsUserRolesAssignmentIdDelete
        >
      >,
      TError,
      { assignmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof revokeUserRoleApiV1PermissionsUserRolesAssignmentIdDelete>
  >,
  TError,
  { assignmentId: string },
  TContext
> => {
  const mutationOptions =
    getRevokeUserRoleApiV1PermissionsUserRolesAssignmentIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get all users assigned to a specific role. Requires admin access.
 * @summary Get Role Assignments
 */
export const getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet = (
  roleId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/role-assignments/${roleId}`,
    method: 'GET',
    signal
  });
};

export const getGetRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGetQueryKey =
  (roleId?: string) => {
    return [`/api/v1/permissions/role-assignments/${roleId}`] as const;
  };

export const getGetRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    roleId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGetQueryKey(
        roleId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
        >
      >
    > = ({ signal }) =>
      getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet(
        roleId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!roleId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
      >
    >
  >;
export type GetRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGetQueryError =
  HTTPValidationError;

export function useGetRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet<
  TData = Awaited<
    ReturnType<
      typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
    >
  >,
  TError = HTTPValidationError
>(
  roleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet<
  TData = Awaited<
    ReturnType<
      typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
    >
  >,
  TError = HTTPValidationError
>(
  roleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet<
  TData = Awaited<
    ReturnType<
      typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
    >
  >,
  TError = HTTPValidationError
>(
  roleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Role Assignments
 */

export function useGetRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet<
  TData = Awaited<
    ReturnType<
      typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
    >
  >,
  TError = HTTPValidationError
>(
  roleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetRoleAssignmentsApiV1PermissionsRoleAssignmentsRoleIdGetQueryOptions(
      roleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all available permissions that can be assigned to roles.

Response:
```json
{
  "permissions": [
    {"code": "*.*.*", "description": "Full admin access"},
    {"code": "*.*.read", "description": "Read access to all entities"},
    ...
  ]
}
```
 * @summary List Available Permissions
 */
export const listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/permissions/available-permissions`,
    method: 'GET',
    signal
  });
};

export const getListAvailablePermissionsApiV1PermissionsAvailablePermissionsGetQueryKey =
  () => {
    return [`/api/v1/permissions/available-permissions`] as const;
  };

export const getListAvailablePermissionsApiV1PermissionsAvailablePermissionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListAvailablePermissionsApiV1PermissionsAvailablePermissionsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
        >
      >
    > = ({ signal }) =>
      listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListAvailablePermissionsApiV1PermissionsAvailablePermissionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
      >
    >
  >;
export type ListAvailablePermissionsApiV1PermissionsAvailablePermissionsGetQueryError =
  unknown;

export function useListAvailablePermissionsApiV1PermissionsAvailablePermissionsGet<
  TData = Awaited<
    ReturnType<
      typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAvailablePermissionsApiV1PermissionsAvailablePermissionsGet<
  TData = Awaited<
    ReturnType<
      typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAvailablePermissionsApiV1PermissionsAvailablePermissionsGet<
  TData = Awaited<
    ReturnType<
      typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Available Permissions
 */

export function useListAvailablePermissionsApiV1PermissionsAvailablePermissionsGet<
  TData = Awaited<
    ReturnType<
      typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAvailablePermissionsApiV1PermissionsAvailablePermissionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListAvailablePermissionsApiV1PermissionsAvailablePermissionsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List every visibility-configurable object_type and the tenant's current mode
(``everyone`` when no row has been set). Powers the settings control + wizard,
and — via ``admin_override_active`` — the governed-list "admin view (beyond your
normal scope)" indicator (§4.1). The override flag is resolved on the EFFECTIVE
identity (``auth.user_id`` — the acting-as user when present), so acting-as
agents always get ``false``.
 * @summary List Visibility Modes
 */
export const listVisibilityModesApiV1PermissionsVisibilityModesGet = (
  signal?: AbortSignal
) => {
  return customInstance<VisibilityModesResponse>({
    url: `/api/v1/permissions/visibility-modes`,
    method: 'GET',
    signal
  });
};

export const getListVisibilityModesApiV1PermissionsVisibilityModesGetQueryKey =
  () => {
    return [`/api/v1/permissions/visibility-modes`] as const;
  };

export const getListVisibilityModesApiV1PermissionsVisibilityModesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listVisibilityModesApiV1PermissionsVisibilityModesGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVisibilityModesApiV1PermissionsVisibilityModesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListVisibilityModesApiV1PermissionsVisibilityModesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listVisibilityModesApiV1PermissionsVisibilityModesGet>
      >
    > = ({ signal }) =>
      listVisibilityModesApiV1PermissionsVisibilityModesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listVisibilityModesApiV1PermissionsVisibilityModesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListVisibilityModesApiV1PermissionsVisibilityModesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listVisibilityModesApiV1PermissionsVisibilityModesGet>
    >
  >;
export type ListVisibilityModesApiV1PermissionsVisibilityModesGetQueryError =
  unknown;

export function useListVisibilityModesApiV1PermissionsVisibilityModesGet<
  TData = Awaited<
    ReturnType<typeof listVisibilityModesApiV1PermissionsVisibilityModesGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVisibilityModesApiV1PermissionsVisibilityModesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listVisibilityModesApiV1PermissionsVisibilityModesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listVisibilityModesApiV1PermissionsVisibilityModesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListVisibilityModesApiV1PermissionsVisibilityModesGet<
  TData = Awaited<
    ReturnType<typeof listVisibilityModesApiV1PermissionsVisibilityModesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVisibilityModesApiV1PermissionsVisibilityModesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listVisibilityModesApiV1PermissionsVisibilityModesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listVisibilityModesApiV1PermissionsVisibilityModesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListVisibilityModesApiV1PermissionsVisibilityModesGet<
  TData = Awaited<
    ReturnType<typeof listVisibilityModesApiV1PermissionsVisibilityModesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVisibilityModesApiV1PermissionsVisibilityModesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Visibility Modes
 */

export function useListVisibilityModesApiV1PermissionsVisibilityModesGet<
  TData = Awaited<
    ReturnType<typeof listVisibilityModesApiV1PermissionsVisibilityModesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVisibilityModesApiV1PermissionsVisibilityModesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListVisibilityModesApiV1PermissionsVisibilityModesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the tenant's visibility mode for one object_type (``everyone`` if unset).
 * @summary Get Visibility Mode
 */
export const getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet = (
  objectType: string,
  signal?: AbortSignal
) => {
  return customInstance<VisibilityModePayload>({
    url: `/api/v1/permissions/visibility-mode/${objectType}`,
    method: 'GET',
    signal
  });
};

export const getGetVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGetQueryKey =
  (objectType?: string) => {
    return [`/api/v1/permissions/visibility-mode/${objectType}`] as const;
  };

export const getGetVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
      >
    >,
    TError = HTTPValidationError
  >(
    objectType: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGetQueryKey(
        objectType
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
        >
      >
    > = ({ signal }) =>
      getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet(
        objectType,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!objectType,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
      >
    >
  >;
export type GetVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGetQueryError =
  HTTPValidationError;

export function useGetVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet<
  TData = Awaited<
    ReturnType<
      typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet<
  TData = Awaited<
    ReturnType<
      typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet<
  TData = Awaited<
    ReturnType<
      typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Visibility Mode
 */

export function useGetVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet<
  TData = Awaited<
    ReturnType<
      typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
    >
  >,
  TError = HTTPValidationError
>(
  objectType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetVisibilityModeApiV1PermissionsVisibilityModeObjectTypeGetQueryOptions(
      objectType,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set the tenant-wide visibility mode for one object_type. Admin only.

Only object_types that declare ``sharing.visibilityConfigurable`` may be set —
this guards the always-filtered ReBAC types (tasks/files) from being flipped to
``everyone`` and leaking across a tenant.
 * @summary Set Visibility Mode
 */
export const setVisibilityModeApiV1PermissionsVisibilityModeObjectTypePut = (
  objectType: string,
  visibilityModeUpdate: VisibilityModeUpdate
) => {
  return customInstance<VisibilityModePayload>({
    url: `/api/v1/permissions/visibility-mode/${objectType}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: visibilityModeUpdate
  });
};

export const getSetVisibilityModeApiV1PermissionsVisibilityModeObjectTypePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setVisibilityModeApiV1PermissionsVisibilityModeObjectTypePut
        >
      >,
      TError,
      { objectType: string; data: VisibilityModeUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setVisibilityModeApiV1PermissionsVisibilityModeObjectTypePut
      >
    >,
    TError,
    { objectType: string; data: VisibilityModeUpdate },
    TContext
  > => {
    const mutationKey = [
      'setVisibilityModeApiV1PermissionsVisibilityModeObjectTypePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setVisibilityModeApiV1PermissionsVisibilityModeObjectTypePut
        >
      >,
      { objectType: string; data: VisibilityModeUpdate }
    > = (props) => {
      const { objectType, data } = props ?? {};

      return setVisibilityModeApiV1PermissionsVisibilityModeObjectTypePut(
        objectType,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetVisibilityModeApiV1PermissionsVisibilityModeObjectTypePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setVisibilityModeApiV1PermissionsVisibilityModeObjectTypePut
      >
    >
  >;
export type SetVisibilityModeApiV1PermissionsVisibilityModeObjectTypePutMutationBody =
  VisibilityModeUpdate;
export type SetVisibilityModeApiV1PermissionsVisibilityModeObjectTypePutMutationError =
  HTTPValidationError;

/**
 * @summary Set Visibility Mode
 */
export const useSetVisibilityModeApiV1PermissionsVisibilityModeObjectTypePut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setVisibilityModeApiV1PermissionsVisibilityModeObjectTypePut
        >
      >,
      TError,
      { objectType: string; data: VisibilityModeUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof setVisibilityModeApiV1PermissionsVisibilityModeObjectTypePut
    >
  >,
  TError,
  { objectType: string; data: VisibilityModeUpdate },
  TContext
> => {
  const mutationOptions =
    getSetVisibilityModeApiV1PermissionsVisibilityModeObjectTypePutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
